<template>
  <div class="surveillance-treatment">
      <el-table
      border
      style="width: 100%"
      >
        <el-table-column
          label="Start Date"
          width="120">
        </el-table-column>
        <el-table-column
          label="End Date"
          width="120">
        </el-table-column>
        <el-table-column
          label="Treatment"
          width="180">
        </el-table-column>
        <el-table-column
          label="Notes">
        </el-table-column>
      </el-table>
  </div>
</template>
<script>
export default {
  name: 'surveillance-treatment',
  props: ['caseData'],
  data: function () {
    return {
    }
  },
  methods: {
    symptomDetail (symptomType) {
      return symptomType + ' detail text goes here'
    }
  }
}
</script>
<style scoped>
div {
    line-height: 3em;
}

.clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

.clearfix {
    clear: both;
    margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// SurveillanceTreatment.vue?3f79c76c